<template>
    <div class="itemgroup-detail">
        <v-container>
            <v-card>
                <v-card-title style="background-color: rgb(33, 57, 141); color: white;">{{$t('productGroup.productGroup')}}</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="valid">
                            <v-text-field
                                    v-model="title"
                                    :rules="titleRules"
                                    :counter="255"
                                    v-bind:label="$t('productGroup.title')"
                                    required
                            ></v-text-field>
                            <v-btn color="primary" @click="saveAction">
                                {{$t('message.save')}}
                            </v-btn>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        mounted() {
            if(this.$route.params.id != null) {
                this.id = this.$route.params.id;
                this.$store.dispatch('productCategories/loadById', {id: this.id}).then(() => {
                    const widget = this.$store.getters['productCategories/byId']({id: this.id});
                    this.title = widget.attributes.title;
                });
            } else {

            }
        },
        methods: {
            ...mapActions({
                delete: 'productCategories/delete',
            }),

            saveAction: function() {
                if(this.$route.params.id != null) {
                    const widget = this.$store.getters['productCategories/byId']({ id: this.id });
                    widget.attributes.title = this.title;
                    this.$store.dispatch('productCategories/update', widget).then(() => {
                        console.log('Test');
                        this.$router.back();
                    });
                } else {
                    const recordData = {
                        attributes: {
                            title: this.title,
                        },
                    };
                    this.$store.dispatch('productCategories/create', recordData).then(() => {
                         this.$router.back();
                        console.log('Test 2');
                    });
                }
            }

        },
        computed: {
            ...mapGetters({
                loading: "productCategories/isLoading",
                error: "productCategories/isError",
            }),
        },
        data: () => ({
            valid: false,
            id: null,
            title: '',
            titleRules: [
                v => !!v || 'Name is required',
                v => v.length <= 255 || 'Name must be less than 255 characters'
            ]
        })
    }
</script>
